export * from './switch-toggle.component'



// WEBPACK FOOTER //
// ./src/app/shared/components/switch-toggle/index.ts